import React from 'react'
import { connect } from 'react-redux'
import '../css/styles.css';

import MainImportantBullets from '../components/mainImportantBullets';

class EquivocalImportantInfo extends React.Component {

    // FIXME Styles/layout
    render() {
        return (
            <div>
                <div style={{fontWeight: 'bold'}}>{this.props.strings.IMPORTANT_EQUIVOCAL_MESSAGE}</div>
                <div>{this.props.strings.IMPORTANT_EQUIVOCAL_BULLETS_HEADER}</div>
                <MainImportantBullets />
            </div>
        );
    }
}

const mapStateToProps = (state, ownProps) => {
    return {
        strings: state.language.strings,
    }
}

const ConnectedEquivocalImportantInfo = connect(
    mapStateToProps
)(EquivocalImportantInfo);
export default ConnectedEquivocalImportantInfo;
